import { ColDef } from "ag-grid-community";

export const getSimpleNumberComparatorFnByField =
  (field: string): ColDef["comparator"] =>
  (_, __, nodeA, nodeB) => {
    const valueA = nodeA?.data?.[field];
    const valueB = nodeB?.data?.[field];

    if (typeof valueA !== "number") {
      return -1;
    }
    if (typeof valueB !== "number") {
      return 1;
    }

    return valueA > valueB ? 1 : -1;
  };
